/**
 * Format cost values for display with appropriate units and precision
 * @param {number} value - The cost value to format
 * @returns {string} - Formatted cost string
 */
export const formatCostValue = (value) => {
    if (value >= 10000000) {
        return `$${(value / 1000000).toFixed(1)}M`;
    } else if (value >= 10000) {
        if (value >= 1000000) {
            return `$${(value / 1000).toLocaleString('en-US', { maximumFractionDigits: 0 })}k`;
        }
        return `$${(value / 1000).toFixed(0)}k`;
    } else if (value >= 20) {
        if (value >= 1000) {
            return `$${value.toLocaleString('en-US', { maximumFractionDigits: 0 })}`;
        }
        return `$${value.toFixed(0)}`;
    } else {
        return `$${value.toFixed(2)}`;
    }
};

/**
 * Format a cost value stored in cents as a full USD currency string.
 * @param {number} cents - The value in cents (e.g. 150000 → "$1,500.00")
 * @returns {string}
 */
export const formatCurrency = (cents, decimals = 2) =>
    new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(cents / 100);

/**
 * Format a decimal value as a percentage string.
 * @param {number} value - The decimal value to format (e.g. 0.25 → "25.00%")
 * @param {number} decimals - The number of decimal places to include
 * @returns {string} - Formatted percentage string
 */
export const formatPercentage = (value, decimals = 2) => `${(value * 100).toFixed(decimals)}%`;